import { PERMIT2_ADDRESS } from "@uniswap/permit2-sdk";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import type { Address } from "viem";
import { useReadContract } from "wagmi";
import { useMemo } from "react";
import { BigNumber } from "@ethersproject/bignumber";
import { permit2 } from "@/abis/permit2";

export interface Permit2AllowanceData {
  amount: BigNumber;
  nonce: number;
  expiration: number;
}

export function usePermit2Allowance(watch: boolean, token: Address, spender?: Address, enable?: boolean): Permit2AllowanceData | undefined {
  const owner = useWeb3UserAddress();
  const args = useMemo(() => [owner || "", token, spender || ""], [owner, spender, token]);

  const { data } = useReadContract({
    address: PERMIT2_ADDRESS,
    abi: permit2,
    functionName: "allowance",
    args: args as [Address, Address, Address],
    query: {
      enabled: !!owner && !!spender && !!enable,
      refetchInterval: watch ? 3000 : false,
    },
  });

  return useMemo(() => {
    return data
      ? {
          amount: BigNumber.from(data[0]),
          nonce: data[1],
          expiration: data[2],
        }
      : undefined;
  }, [data]);
}
